import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { FileKind } from "../../../define/FileKind";
import { GeneralKind } from "../../../define/GeneralKind";
import { SettleLawsuitKind } from "../../../define/SettleLawsuitKind";
import NormalGameManager from "../../manager/NormalGameManager";
import SettleLawsuitItemNode from "./SettleLawsuitItemNode";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettlLawSuitSelectLayer extends BasePopUpLayer {

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Prefab, displayName:"levelItem"})
    levelItem:cc.Prefab = null;

    @property({type:cc.Label,displayName:"剩余案件次数文本"})
    labelCount:cc.Label = null;

    start(){
        // O1HD.on(MessageEventKind.EventName.LEVEL_JUDGE, this.levelJudge, this);
        
        this.initLayer();

        // NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.GOVERNMENT);
        // this.levelJudge();
    }

    // protected onDestroy(): void {
    //     O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.GOVERNMENT);
    // }

    // levelJudge() {
    //     utilsView.enterLayerDispose(UIKind.UILayerTag.GOVERNMENT, this.node);
    // }
    
    //加载
    initLayer(){
        this.refreshUseCount();
        this.showList();
        // let gameManager = NormalGameManager._instance;
        // let gameData = gameManager.getGameData();
        // let curTime = Date.now();
        // if (data_control.isNextDay(curTime, gameData.lastRefreshCaseDate)) {
        //     this.refreshList();
        // } else {
        //     this.showListUI(gameData.settleLawsuitList);
        // }
    }

    showList() {
        this.itemContent.removeAllChildren();
        let ValueChangeType = GeneralKind.ValueChangeType;
        let csvName = this._carryData.csvFile;
        let prefab = this._carryData.prefab;
        let csvInfo = CsvDataManage.instance.getCsvData(csvName); 
        let title = csvInfo.title;
        for (let i in csvInfo) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }
            let info = csvInfo[i];

            let strSuccess = info[title.success];
            let splitsSuc = utilsModel.splitLineFeed(strSuccess);
            if (!splitsSuc) {
                console.error(`数据错误`);
                continue;
            }

            let gold = 0;
            let exp = 0;
            let bHaveGood = false;
            for (let oj of splitsSuc) {
                let splitsSucuc = oj.split(FileKind.ResParseType.SUB_ITEM);
                let type = splitsSucuc[0];
                switch(type) {
                    case ValueChangeType.GOLD: {
                        gold = Number(splitsSucuc[1]);
                    }
                    break;
                    case ValueChangeType.GOODS_GET: {
                        bHaveGood = true;
                    }
                    break;
                    case ValueChangeType.PRESTIGE: {
                        exp = Number(splitsSucuc[1]);
                    }
                    break;
                }
            }
            let nodeItem = cc.instantiate(this.levelItem);
            this.itemContent.addChild(nodeItem);
            let nodeScript = nodeItem.getComponent(SettleLawsuitItemNode);
            nodeScript.setCarryData({
                name: info[title.name]
                , caseId: i
                , prefab: prefab
                , star: Number(info[title.star])
                , parent: this
                , gold: gold
                , exp: exp
                , bHaveGood: bHaveGood
            });
        }
    }

    getListFromProbability() {
        let csvInfo = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.LEGAL_CASE_CONFIG);
        let title = csvInfo.title;
        // 概率
        let probability_basic = Number(csvInfo.probability_basic[title.value]);
        let probability_main = Number(csvInfo.probability_main[title.value]);
        let probability_special = Number(csvInfo.probability_special[title.value]);
        let needCount = 6;
        let configAry = [
            CsvFileKind.CsvFile.LEGAL_CASE_PRIMARY,
            CsvFileKind.CsvFile.LEGAL_CASE_MAIN,
            CsvFileKind.CsvFile.LEGAL_CASE_SPECIAL
        ];
        let probabilityArr = [
            probability_basic
            , probability_main + probability_basic
            , probability_special + probability_main + probability_basic
        ]
        let retArr: string[][] = [];
        let csvIdArr: string[][] = [];
        let totalNum = 0;
        for(let i = 0; i < configAry.length; i++){
            let o = configAry[i];
            csvIdArr[i] = CsvDataManage.instance.getCsvIds(o);
            totalNum += csvIdArr[i].length;
        }
        if (needCount < totalNum) {
            let tn = 0;
            while(tn < 6) {
                // 获得一个随机数组
                let randomNum = data_control.randomNum(0, 100);
                let k = probabilityArr.length-1;
                for (let j = 0; j < probabilityArr.length; j++) {
                    if (randomNum <= probabilityArr[j]) {
                        k = j;
                        break;
                    }
                }
                if (csvIdArr[k].length <= 0) {
                    continue;
                }

                let idx = data_control.randomNumInt(0, csvIdArr[k].length - 1);
                retArr.push([String(k), csvIdArr[k][idx]]);
                csvIdArr[k].splice(idx, 1);
                tn++;
            }
        } else {
            for (let i = 0; i < csvIdArr.length; i++) {
                let o = csvIdArr[i];
                for (let oi of o) {
                    retArr.push([String(i), oi]);
                }
            }
        }
        return retArr;
    }

    refreshList() {
        let retArr = this.getListFromProbability();
        
        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        gameData.lastRefreshCaseDate = Date.now();
        gameData.settleLawsuitList = retArr;
        gameManager.writeGameData();
        this.showListUI(retArr);
    }

    showListUI(retArr: string[][]) {
        let configAry = [
            CsvFileKind.CsvFile.LEGAL_CASE_PRIMARY,
            CsvFileKind.CsvFile.LEGAL_CASE_MAIN,
            CsvFileKind.CsvFile.LEGAL_CASE_SPECIAL
        ];  
        let prefabArr = [
            FileKind.PrefabFilePath.SettleLawsuitPrimaryLayer,
            FileKind.PrefabFilePath.SettleLawsuitMainLayer,
            FileKind.PrefabFilePath.SettleLawsuitSpecialLayer,
        ];  
        this.itemContent.removeAllChildren();
        let ValueChangeType = GeneralKind.ValueChangeType;
        for (let i = 0; i < retArr.length; i++) {
            let o = retArr[i];
            let arrIdx = Number(o[0]);
            let csvName = configAry[arrIdx];
            let csvInfo = CsvDataManage.instance.getCsvData(csvName);
            if (!csvInfo) {
                console.error(`未找到表格 ${o}`);
                return;
            }
            let caseId = o[1];
            let title = csvInfo.title;
            let info = csvInfo[caseId];
            let splitsSuc: string[] = null;
            if (csvName == CsvFileKind.CsvFile.LEGAL_CASE_PRIMARY) {
                let peopleSplits = utilsModel.splitLineFeed(info[title.people]);
                for (let p = 1; p <= peopleSplits.length; p++) {
                    let resultArr = utilsModel.splitLineFeed(info[title['judge_result_award' + p]]);
                    if (resultArr[0] != ValueChangeType.NONE) {
                        splitsSuc = resultArr[0].split(FileKind.ResParseType.ITEM);
                        break;
                    }
                }
            } else {
                let strSuccess = info[title.success];
                splitsSuc = utilsModel.splitLineFeed(strSuccess);
            }
            if (!splitsSuc) {
                console.error(`数据错误`);
                continue;
            }

            let gold = 0;
            let exp = 0;
            let bHaveGood = false;
            for (let oj of splitsSuc) {
                let splitsSucuc = oj.split(FileKind.ResParseType.SUB_ITEM);
                let type = splitsSucuc[0];
                switch(type) {
                    case ValueChangeType.GOLD: {
                        gold = Number(splitsSucuc[1]);
                    }
                    break;
                    case ValueChangeType.GOODS_GET: {
                        bHaveGood = true;
                    }
                    break;
                    case ValueChangeType.PRESTIGE: {
                        exp = Number(splitsSucuc[1]);
                    }
                    break;
                }
            }
            cc.log(arrIdx == 0? '初级玩法' : (arrIdx == 1 ? '主要玩法' : '特殊玩法'), caseId);
            let nodeItem = cc.instantiate(this.levelItem);
            this.itemContent.addChild(nodeItem);
            let nodeScript = nodeItem.getComponent(SettleLawsuitItemNode);
            nodeScript.setCarryData({
                name: info[title.name]
                , caseId: caseId
                , prefab: prefabArr[arrIdx]
                , star: Number(info[title.star])
                , parent: this
                , gold: gold
                , exp: exp
                , bHaveGood: bHaveGood
            });
        }
    }

    refreshUseCount() {
        let gameManager = NormalGameManager._instance;
        let gameData = gameManager.getGameData();
        let todaySettleLawsuitUseCount = gameData.todaySettleLawsuitUseCount;
        let maxCount = SettleLawsuitKind.GeneralValue.MAX_USE_COUNT;
        this.labelCount.string = `今日剩余断案次数${todaySettleLawsuitUseCount}/${maxCount}`;
    }

    onClickAd() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.refreshList();
        },()=>{

        },null,"断案观看广告刷新列表")
    }

    onClickClose() {
        this.destroyNode();
    }
}
